import { render, staticRenderFns } from "./handicapList.vue?vue&type=template&id=2118f3f1&scoped=true&lang=html"
import script from "./handicapList.vue?vue&type=script&lang=js"
export * from "./handicapList.vue?vue&type=script&lang=js"
import style0 from "./handicapList.vue?vue&type=style&index=0&id=2118f3f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118f3f1",
  null
  
)

export default component.exports